import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../store/reducer/PopupReducer";
import CustomTable from "../../ui/custom-table";
import {
  deleteDeviceControllers,
  getAllDeviceControllers,
} from "../../api/api";

function Controllers() {
  const dispatch = useDispatch();
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const { showModal } = useSelector(
    (state) => state?.PopupReducer?.modal || {}
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500); // Debounce by 500ms

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const fetchDeviceControllers = async () => {
    setLoading(true);
    try {
      const search = debouncedSearch;
      const data = await getAllDeviceControllers(
        search,
        user_id,
        organization_id
      );
      if (data?.data?.status === true) {
        setDevices(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeviceControllers();
  }, [debouncedSearch]);

  useEffect(() => {
    if (showModal === false) {
      fetchDeviceControllers();
    }
  }, [showModal]);

  const columns = useMemo(
    () => [
      { accessorKey: "device_name", header: "Device Name" },
      { accessorKey: "camera_grp_name", header: "Camera group name" },
      { accessorKey: "ip_address", header: "IP" },
      { accessorKey: "device_port", header: "Port" },
      { accessorKey: "alert", header: "Alert" },
      { accessorKey: "action", header: "Action" },
    ],
    []
  );

  const handleAddClick = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "ADD_CONTROLLER",
        showModal: true,
      })
    );
  };

  const handleDelete = (controller) => {
    //console.log("[INFO] Controllers: ", controller);
    deleteDeviceControllers(controller?._id,user_id,organization_id);

    setDevices((prev) => [
      ...prev.filter((ele) => ele?._id !== controller?._id),
    ]);
  };

  const handleEdit = (row) => {
    dispatch(
      SetPopupReducerData({
        modalType: "ADD_CONTROLLER",
        showModal: true,
        data: row._id,
      })
    );
  };

  return (
    <>
      <aside className="mainSection">
        <CustomTable
          columns={columns}
          data={devices}
          loading={loading}
          onAddClick={handleAddClick}
          addButtonLabel="Add Controller"
          showActions={true}
          onDelete={handleDelete}
          onSearchChange={(e) => {
            setSearchTerm(e.target.value);
          }}
          onEdit={handleEdit}
        />
      </aside>
    </>
  );
}

export default Controllers;
